import goog from "@tastyworks/boulangerie-bundle"
import type { AdminMarketData, Position } from "@tastyworks/tastyworks-api"

const TwSymbolUtil = goog.module.get("com.dough.trade.util.TwSymbolUtil")
const SecurityFormatter = goog.module.get("com.dough.text.SecurityFormatter")

export class PositionRow {
  security: any

  constructor(
    readonly position: Position,
    readonly marketData: AdminMarketData | undefined
  ) {
    this.security = TwSymbolUtil.toSecurity(
      position.symbol,
      position.instrumentType
    )
  }

  get bid() {
    return formatQuotePrice(this.marketData?.bid)
  }

  get ask() {
    return formatQuotePrice(this.marketData?.ask)
  }

  get last() {
    return formatQuotePrice(this.marketData?.last)
  }

  get underlyingSymbol() {
    if (this.instrumentType === "Future") {
      return this.position.symbol
    }
    return this.position.underlyingSymbol
  }

  get instrumentType() {
    return this.position.instrumentType
  }

  get costPerUnit() {
    return {
      value: this.position.averageOpenPrice,
      direction: this.position.quantityDirection,
    }
  }

  get quantity() {
    return formatPositionQuantity(this.position)
  }

  get expirationDate() {
    return this.security.expirationDate
  }

  get daysToExpiration() {
    return SecurityFormatter.daysToExpiration(this.security)
  }

  get strikePrice() {
    return this.security.strikePrice
  }

  get callOrPut() {
    return this.security.callOrPut
  }

  get callPutStock() {
    switch (this.instrumentType) {
      case "Equity Option":
      case "Future Option":
        return this.security.simplifiedAssetType
      case "Equity":
        return "Shares"
      case "Future":
        return "Futures"
      default:
        return ""
    }
  }
}

const formatQuotePrice = (price: number | undefined): string =>
  !price || isNaN(price) ? "--" : `${price}`

const getSign = (quantityDirection: string): string => {
  switch (quantityDirection) {
    case "Long":
      return "+"
    case "Short":
      return "-"
    default:
      return ""
  }
}

const formatPositionQuantity = (position: Position): string => {
  return getSign(position.quantityDirection) + position.quantity
}
